import BaseTemplate from '../../components/baseTemplate';
import { createBrowserHistory } from 'history';
import { useDispatch } from 'react-redux';
import { useLocalization } from 'src/utils/useLocalization';
import { USER_ACTIONS } from '../../../../utils/enums/user-store-actions.enum';
//import React from 'react';
import './styles.scss';

const RegisterSuccessful = () => {
    const { registrationSuccess } = useLocalization();
    const userDispatch = useDispatch();

    function returnLogin() {
        const history = createBrowserHistory();
        sessionStorage.clear();
        userDispatch({
            type: USER_ACTIONS.LOGOUT,
            payload: undefined,
        });
        history.push('/login');
        location.reload();
    }

    return (
        <BaseTemplate>
            <div className={'main-form reg-form'}>
                <div className={'reg-title u-mb-xxsmall u-mt-xlarge'}>
                    <h4>{registrationSuccess.REG_SUCC_TITLE}</h4>
                    <p>{registrationSuccess.REG_SUCC_SUBTITLE}</p>
                    <p>{registrationSuccess.REG_SUCC_TEXT}</p>
                </div>
                <div className='sg-component-variant'>
                    <form onSubmit={returnLogin}>
                        <button
                            className='main-btn c-btn c-btn--full reg-button'
                            type={'submit'}
                        >
                            <span className='c-btn__text'>
                                {registrationSuccess.REG_SUCC_BUTTON}
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </BaseTemplate>
    );
};

export default RegisterSuccessful;
